/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["self"] } ] */
import { types, Instance } from 'mobx-state-tree';

export const SiteLimitation = types
  .model({
    key: types.string,
    value: types.string,
  })
  .views(self => ({
    get bool(): boolean {
      if (!['Y', 'y', 'N', 'n'].includes(self.value)) {
        // eslint-disable-next-line no-console
        console.warn('%s is not a boolean. Value: %s', self.key, self.value);
      }
      return self.value === 'Y' || self.value === 'y';
    },
  }));

export interface ISiteLimitation extends Instance<typeof SiteLimitation> {}
